import axios from "axios"
import { toast } from "react-toastify"
import { InternetConnection } from "../../Utils/InternetConnection"
// the details of individual profile
export const state = {
    uid: "",
    regid: 0,
    firstName: "User",
    lastName: "User",
    address: "",
    state: "",
    department: "",
    panCard: "",
    aadharCard: "",
    dob: "",
    resumeLink: "",
    phoneno: "",
    email: "",
    batch: "",
    personalEmail: "",
    img: "",
    linkedInLink: "",
    githubLink: "",
    marks: {
        class10: 0,
        class12: 0,
        cgpa: 0,
        sem1: 0,
        sem2: 0,
        sem3: 0,
        sem4: 0,
        sem5: 0,
        sem6: 0,
        sem7: 0,
        sem8: 0,
    },
    role: "",
    placed: false,
    accountStatus: "pending",
    createDate: "",
    updateDate: ""
}
export const reducerFunction = (state, action) => {
    switch (action.type) {
        case "setUID":
            return { ...state, uid: action.payload }
        case "setRegistrationNumber":
            return { ...state, regid: action.payload }
        case "setFirstName":
            return { ...state, firstName: action.payload }
        case "setLastName":
            return { ...state, lastName: action.payload }
        case "setAddress":
            return { ...state, address: action.payload }
        case "setState":
            return { ...state, state: action.payload }
        case "setDepartment":
            return { ...state, department: action.payload }
        case "setPanCard":
            return { ...state, panCard: action.payload }
        case "setAadharCard":
            return { ...state, aadharCard: action.payload }
        case "setdob":
            return { ...state, dob: action.payload }
        case "setResumeLink":
            return { ...state, resumeLink: action.payload }
        case "setPhoneNo":
            return { ...state, phoneno: action.payload }
        case "setEmail":
            return { ...state, email: action.payload }
        case "setbatch":
            return { ...state, batch: action.payload }
        case "personalEmail":
            return { ...state, personalEmail: action.payload }
        case "setImg":
            return { ...state, img: action.payload }
        case "setLinkedinLink":
            return { ...state, linkedInLink: action.payload }
        case "setgithubLink":
            return { ...state, githubLink: action.payload }
        case "setMarks":
            return { ...state, marks: action.payload }
        case "setRole":
            return { ...state, role: action.payload }
        case "clear":
            return {
                ...state, uid: "",
                regid: "",
                firstName: "",
                lastName: "",
                address: "",
                state: "",
                department: "",
                panCard: "",
                aadharCard: 0,
                dob: "",
                resumeLink: "",
                phoneno: "",
                email: "",
                batch: "",
                personalEmail: "",
                img: "",
                linkedInLink: "",
                githubLink: "",
                marks: {
                    class10: 0,
                    class12: 0,
                    cgpa: 0,
                    sem1: 0,
                    sem2: 0,
                    sem3: 0,
                    sem4: 0,
                    sem5: 0,
                    sem6: 0,
                    sem7: 0,
                    sem8: 0,
                },
                role: "",
                placed: false,
                accountStatus: "pending",
                createDate: "",
                updateDate: ""
            }
        default:
            return { ...state }
    }
}
// get the user profile (which has been logged into the system)
export const getUserDetails = async (userDispatch, navigate) => {
    try {
        if (!(InternetConnection())) {
            toast.error("No internet connection!")
            return;
        }
        const token = localStorage.getItem("token")
        const data = await axios.get("https://tpsmit-backend.onrender.com/student/profile/read", { headers: { token } })
        const { aadharCard, regid, firstName, lastName, address, state, department, panCard, dob, resumeLink, phoneno, email, batch, img, linkedInLink, githubLink, marks, role, personalEmail, uid } = data?.data?.message[0]
        userDispatch({ type: "setUID", payload: uid })
        userDispatch({ type: "setRegistrationNumber", payload: regid })
        userDispatch({ type: "setFirstName", payload: firstName })
        userDispatch({ type: "setLastName", payload: lastName })
        userDispatch({ type: "setAddress", payload: address })
        userDispatch({ type: "personalEmail", payload: personalEmail })
        userDispatch({ type: "setState", payload: state })
        userDispatch({ type: "setDepartment", payload: department })
        userDispatch({ type: "setPanCard", payload: panCard })
        userDispatch({ type: "setAadharCard", payload: aadharCard })
        userDispatch({ type: "setdob", payload: dob })
        userDispatch({ type: "setResumeLink", payload: resumeLink })
        userDispatch({ type: "setPhoneNo", payload: phoneno })
        userDispatch({ type: "setEmail", payload: email })
        userDispatch({ type: "setbatch", payload: batch })
        userDispatch({ type: "setImg", payload: img })
        userDispatch({ type: "setLinkedinLink", payload: linkedInLink })
        userDispatch({ type: "setgithubLink", payload: githubLink })
        userDispatch({ type: "setMarks", payload: marks })
        userDispatch({ type: "setRole", payload: role })
    } catch (err) {
        if (!localStorage.getItem("token")) {
            return
        }
        toast.error(err.response.data.message)
        localStorage.clear()
        navigate("/login")
    }


}

export const editUserDetails = async (editLoading, setEditLoading, editState, userDispatch, navigate,userDetailsByRegId) => {
    try {
        if (!(InternetConnection())) {
            toast.error("No internet connection!")
            return;
        }
        const token = localStorage.getItem("token")
        const data = await axios.post("https://tpsmit-backend.onrender.com/student/profile/edit", editState, { headers: { token } })
        toast.success("Profile edited !")
        const { aadharCard, firstName, lastName, address, state, department, panCard, dob, resumeLink, phoneno, email, batch, img, linkedInLink, githubLink, marks, role, personalEmail, uid, regid } = data?.data?.message[0]
        userDispatch({ type: "setUID", payload: uid })
        userDispatch({ type: "setFirstName", payload: firstName })
        userDispatch({ type: "setLastName", payload: lastName })
        userDispatch({ type: "setAddress", payload: address })
        userDispatch({ type: "personalEmail", payload: personalEmail })
        userDispatch({ type: "setState", payload: state })
        userDispatch({ type: "setDepartment", payload: department })
        userDispatch({ type: "setPanCard", payload: panCard })
        userDispatch({ type: "setAadharCard", payload: aadharCard })
        userDispatch({ type: "setdob", payload: dob })
        userDispatch({ type: "setResumeLink", payload: resumeLink })
        userDispatch({ type: "setPhoneNo", payload: phoneno })
        userDispatch({ type: "setEmail", payload: email })
        userDispatch({ type: "setbatch", payload: batch })
        userDispatch({ type: "setImg", payload: img })
        userDispatch({ type: "setLinkedinLink", payload: linkedInLink })
        userDispatch({ type: "setgithubLink", payload: githubLink })
        userDispatch({ type: "setMarks", payload: marks })
        userDispatch({ type: "setRole", payload: role })
        navigate(`/${role}/${regid}` || "/home")
    } catch (err) {
        toast.error(err.response.data.message)
    }
}
// get the details of the user by their id
export const getUserDetailsByRegId = async (regid, setuserDetailsByRegId) => {

    try {
        if (!(InternetConnection())) {
            toast.error("No internet connection!")
            return;
        }
        const token = localStorage.getItem("token")
        const data = await axios.get(`https://tpsmit-backend.onrender.com/student/profile/read/${regid}`, { headers: { token } })
        setuserDetailsByRegId(data.data.message[0])
    } catch (err) {
        if (!localStorage.getItem("token")) {
            return
        }
        toast.error(err.response.data.message)
    }
}
// edit admin self
export const editAdminSelf = async (editLoading, setEditLoading, editState, userDispatch, navigate) => {
    try {
        if (!(InternetConnection())) {
            toast.error("No internet connection!")
            return;
        }
        const token = localStorage.getItem("token")
        const data = await axios.post("https://tpsmit-backend.onrender.com/admin/profile/edit/self", editState, { headers: { token } })
        toast.success("Profile edited !")
        const { img, firstName, lastName, department, phoneno, email, role, personalEmail, uid, regid } = data?.data?.message[0]
        userDispatch({ type: "setUID", payload: uid })
        userDispatch({ type: "setFirstName", payload: firstName })
        userDispatch({ type: "setLastName", payload: lastName })
        userDispatch({ type: "personalEmail", payload: personalEmail })
        userDispatch({ type: "setDepartment", payload: department })
        userDispatch({ type: "setPhoneNo", payload: phoneno })
        userDispatch({ type: "setEmail", payload: email })
        userDispatch({ type: "setImg", payload: img })
        userDispatch({ type: "setRole", payload: role })
        navigate(`/${role}/${regid}` || "/home")
    } catch (err) {
        toast.error(err.response.data.message)
    }
}


// edit student by admin
export const editStudentByAdmin = async (editLoading, setEditLoading, editState, userDispatch, navigate,userDetailsByRegId) => {
    try {
        if (!(InternetConnection())) {
            toast.error("No internet connection!")
            return;
        }
        const token = localStorage.getItem("token")
        const data = await axios.post(`https://tpsmit-backend.onrender.com/admin/profile/edit/student/${userDetailsByRegId.regid}`, editState, { headers: { token } })
        toast.success("Profile edited !")
        const { role, regid } = data?.data?.message[0]
        navigate(`/${role}/${regid}` || "/home")
    } catch (err) {
        toast.error(err.response.data.message)
    }
}